"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoWrapStyled = exports.LogoContainerStyled = exports.Line3Styled = exports.Line2Styled = exports.Line1Styled = exports.ButtonWrapp = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _heroSlide = require("../../hero-slide.styled");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          img {\n            height: 100px;\n            ", " {\n              height: 90px;\n            }\n          }\n          ", " {\n            position: static;\n            height: 100px;\n            width: 100px;\n            ", " {\n              height: 90px;\n              width: 90px;\n            }\n          }\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n          img {\n            height: 40px;\n            ", " {\n              height: 30px;\n            }\n          }\n          ", " {\n            position: static;\n            height: 40px;\n            ", " {\n              height: 30px;\n            }\n          }\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-bottom: 15px;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 15px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: -12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n\n  &:first-of-type {\n    margin-top: 30px;\n\n    ", " {\n      margin-top: 15px;\n    }\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonWrapp = (0, _uiKit.styled)("div")(_templateObject(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ButtonWrapp = ButtonWrapp;
var Line1Styled = (0, _uiKit.styled)(_heroSlide.Line1)(_templateObject2());
exports.Line1Styled = Line1Styled;
var Line2Styled = (0, _uiKit.styled)(_heroSlide.Line2)(_templateObject3());
exports.Line2Styled = Line2Styled;
var Line3Styled = (0, _uiKit.styled)(_heroSlide.Line3)(_templateObject4());
exports.Line3Styled = Line3Styled;
var LogoContainerStyled = (0, _uiKit.styled)("span")(_templateObject5());
exports.LogoContainerStyled = LogoContainerStyled;
var LogoWrapStyled = (0, _uiKit.styled)("span")(_templateObject6(), function (_ref) {
  var isHorizontal = _ref.isHorizontal;
  return isHorizontal ? (0, _uiKit.css)(_templateObject7(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.LoadingBlockStyled, _uiKit.GridBreakpointsMediaDown.lg) : (0, _uiKit.css)(_templateObject8(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.LoadingBlockStyled, _uiKit.GridBreakpointsMediaDown.lg);
});
exports.LogoWrapStyled = LogoWrapStyled;